import { render, staticRenderFns } from "./MatchOptionsAddress.vue?vue&type=template&id=1c297c8e&scoped=true&"
import script from "./MatchOptionsAddress.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsAddress.vue?vue&type=script&lang=js&"
import style0 from "./MatchOptionsAddress.vue?vue&type=style&index=0&id=1c297c8e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c297c8e",
  null
  
)

export default component.exports